import axios, { CancelTokenSource } from 'axios'
import React, { Suspense, useEffect, useRef, useState } from 'react'
import { MainArticleLayout } from '../../layouts/MainArticleLayout'
import { UserProfile } from '../../models/Profile'
import ProfileService from '../../services/ProfileService'
import Protected from '../Protected'

const EnquiryTable = React.lazy(() => import('./enquiry-table/EnquiryTable'))
const EnquiryInfo = React.lazy(() => import('./enquiry/EnquiryInfo'))
const WorkplaceFooter = React.lazy(() => import('../common/WorkplaceFooter'))

const Enquiries = () => {
  const mountedRef = useRef(false)
  const [isLoading, setIsLoading] = useState(true)
  const [userProfile, setUserProfile] = useState<UserProfile>()
  const { getCurrentUserProfile } = ProfileService

  useEffect(() => {
    mountedRef.current = true
    const source = axios.CancelToken.source()
    fetchCurrentUserProfile(source)
      .then((profile) => {
        if (mountedRef.current) {
          setUserProfile(profile)
        }
      })
      .finally(() => {
        if (mountedRef.current) {
          setIsLoading(false)
        }
      })

    return () => {
      mountedRef.current = false
      if (source) {
        source.cancel('Operation cancelled')
      }
    }
  }, [])

  useEffect(() => {
    mountedRef.current = true
    if (sessionStorage.getItem('Reload') === 'true') {
      sessionStorage.removeItem('Reload')
      window.location.reload()
    }

    return () => {
      mountedRef.current = false
    }
  }, [])
  const fetchCurrentUserProfile = async (source: CancelTokenSource) => {
    return await getCurrentUserProfile(source).then((response) => {
      return response.result
    })
  }

  return (
    <Protected>
      <Suspense fallback={null}>
        <MainArticleLayout>
          <EnquiryTable size={10} limit={1000} />
          <EnquiryInfo />
        </MainArticleLayout>
        <br />
        <WorkplaceFooter userProfile={userProfile} isLoading={isLoading} />
      </Suspense>
    </Protected>
  )
}

export default Enquiries
